"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var KeyboardShortcutsFull_1 = require("./view/KeyboardShortcutsFull");
var isKeyboardShortcutsOptionDirty_1 = require("./utils/isKeyboardShortcutsOptionDirty");
var discardKeyboardShortcutsOption_1 = require("./data/mutators/discardKeyboardShortcutsOption");
var saveKeyboardShortcutsOption_1 = require("./orchestration/saveKeyboardShortcutsOption");
var KeyboardShortcutsOption = {
    key: 'shortcuts',
    titleStringKey: 'optionTitle_shortcuts',
    searchTermsStringKey: 'optionTitle_shortcuts',
    fullOptionFormSettings: {
        render: function () { return React.createElement(KeyboardShortcutsFull_1.default, null); },
        isDirty: isKeyboardShortcutsOptionDirty_1.default,
        onSave: saveKeyboardShortcutsOption_1.default,
        onDiscard: discardKeyboardShortcutsOption_1.default,
    },
};
exports.default = KeyboardShortcutsOption;
//# sourceMappingURL=KeyboardShortcutsOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/general/owa-shortcut-option/lib/KeyboardShortcutsOption.js
// module id = 4970
// module chunks = 2